<template>
  <div class="account-balance-modal">
    <button @click.prevent="$vModal.close('cash-request')"
            class="account-balance-modal__close base-btn">
      <BaseSvg name="ico-close"
               width=".9rem"
               height=".9rem"
      />
    </button>
    <div class="account-balance-modal__title">{{ $tAccount('Withdrawal request') }}</div>
    <div class="account-balance-modal__subtitle">
      <span style="color: #727272">1 JBN</span>
      <span style="margin-left: 0.25em">= 1 UAH</span>
    </div>

    <AccountBalanceInfo :label="$tAccount('Available for withdrawal')"
                        :value="canWithdrawSum"
                        class="_withdraw"/>

    <div class="account-balance-modal__details">
      <div class="account-balance-modal__details-title">
        {{ $tAccount('How much would you like to withdraw?') }}
      </div>

      <BaseInput v-model="sum"
                 :error="cardInputs.sum.error"
                 class="_white"
                 type="number"/>

      <div class="account-balance-modal__details-type">
        <div class="account-balance-modal__details-type-item"
             :class="{ _active: type === TYPE_CARD }"
             @click="type = TYPE_CARD">
          <BaseSvg class="account-balance-modal__details-type-active-flag"
                   name="ico-check-round"/>

          <!--          <BaseSvg name="ico-passport-card" class="account-balance-modal__details-type-ico"/>-->
          <img src="../../assets/img/withdraw-card.png" alt="card" class="account-balance-modal__details-type-ico">
          <span class="account-balance-modal__details-type-title">
            {{ $tAccount('Transfer to card') }}
          </span>
        </div>

        <div class="account-balance-modal__details-type-item"
             :class="{ _active: type === TYPE_OTHER }"
             @click="type = TYPE_OTHER">
          <BaseSvg
              class="account-balance-modal__details-type-active-flag"
              name="ico-check-round"/>
          <img src="../../assets/img/withdraw-wallet.png" alt="wallet" class="account-balance-modal__details-type-ico">
          <!--          <BaseSvg name="ico-wallet-2" class="account-balance-modal__details-type-ico"/>-->
          <span class="account-balance-modal__details-type-title">
            {{ $tAccount('Another way') }}
          </span>
        </div>
      </div>

      <transition name="fade">
        <div v-if="type === TYPE_CARD"
             class="account-balance-modal__details-inputs">
          <BaseInput v-model="cardInputs.number.value"
                     :error="cardInputs.number.error"
                     class="_white"
                     mask="#### #### #### ####"
                     :label="$tAccount('Card number')"/>
<!--          <div class="input-group">-->
<!--            <div class="input-group">-->
<!--              <BaseInput v-model="cardInputs.expired_month.value"-->
<!--                         :error="cardInputs.expired_month.error"-->
<!--                         class="_white"-->
<!--                         type="number"-->
<!--                         mask="##"-->
<!--                         :label="$tAccount('Validity')"-->
<!--                         absolute/>-->
<!--              <span style="margin: 1.5em 0.25em 0">/</span>-->
<!--              <BaseInput v-model="cardInputs.expired_year.value"-->
<!--                         :error="cardInputs.expired_year.error"-->
<!--                         class="_white _invisible-label"-->
<!--                         type="number"-->
<!--                         mask="##"-->
<!--                         :label="$tAccount('Validity')"/>-->
<!--            </div>-->
<!--            <BaseInput v-model="cardInputs.cvv.value"-->
<!--                       :error="cardInputs.cvv.error"-->
<!--                       class="_white"-->
<!--                       type="number"-->
<!--                       mask="###"-->
<!--                       label="CVV"/>-->
<!--          </div>-->
        </div>
      </transition>
    </div>
    <BaseAlert :value="overallErrorsMix"
               class="account-balance-modal__error  _warning"/>

    <button v-if="isValid"
            @click.prevent="send"
            class="account-balance-modal__button base-btn base-btn--blue-dark">
      <span class="base-btn__text">{{ $tAccount('Send request') }}</span>
      <BaseSvg name="ico-arrow-light"/>
      <BasePreloader v-if="pending"/>
    </button>
    <button v-else
            disabled
            class="account-balance-modal__button base-btn base-btn--blue-dark">
      <span class="base-btn__text">{{ $tAccount('Send request') }}</span>
      <BaseSvg name="ico-arrow-light"/>
    </button>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formMixins from '@/mixins/formMixins'
  import AccountBalanceInfo from '@/components/accountBalance/AccountBalanceInfo'

  const TYPE_CARD = 1
  const TYPE_OTHER = 2

  export default {
    name: 'AccountBalanceCashRequestModal',
    mixins: [formMixins],
    components: {AccountBalanceInfo},
    props: {
      canWithdrawSum: Number
    },
    data() {
      return {
        pending: false,
        TYPE_CARD,
        TYPE_OTHER,
        sum: null,
        type: null,
        cardInputs: {
          sum: {
            value: null
          },
          number: {
            value: null
          },
          // expired_month: {
          //   value: null
          // },
          // expired_year: {
          //   value: null
          // },
          // cvv: {
          //   value: null
          // },
        }
      }
    },
    computed: {
      isValid() {
        return !!(
            this.sum
            && this.type
            && this.cardInputs.number.value && this.cardInputs.number.value.length === 19
            // && this.cardInputs.expired_month.value
            // && this.cardInputs.expired_year.value
            // && this.cardInputs.cvv.value
        );
      }
    },
    methods: {
      send() {
        this.resetErrorsMix(this.cardInputs)

        const sum = Number(this.sum)
        if (sum > this.canWithdrawSum) {
          return this.overallErrorsMix = this.$tAccount('You can not withdraw more than') + ' ' + this.canWithdrawSum
        }

        this.cardInputs.sum.value = sum
        const sendData = this.createSendDataMix(this.cardInputs)
        sendData.number = sendData.number.replace(/ /g, '')
        sendData.type = this.type

        this.pending = true

        http.post('/api/cabinet/payments/withdraw', sendData).then(() => {
          this.$vModal.close('cash-request')
          this.$vModal.open('message', {
            title: this.$tAccount('Withdraw is successful!'),
          })
        }).catch(error => {
          this.errorHandlerMix(error, this.cardInputs)
        }).finally(() => {
          this.pending = false
        })
      }
    }
  };
</script>
